<template>
  <v-text-field-money
    :value="value"
    :label="label"
    :properties="propriedades"
    :options="opcoes"
    :class="compacto ? '' : campo"
    @input="$emit('input', $event)"
  />
</template>
<script>
import { CAMPO } from "./folhaUi";

// Valor em reais (ou com outro prefixo/sufixo) no padrão do projeto: máscara do v-text-field-money, vazio = nulo.
export default {
  name: "CampoValorFolha",
  props: {
    value: { type: [String, Number], default: null },
    label: { type: String, default: "" },
    prefixo: { type: String, default: "R$" },
    sufixo: { type: String, default: "" },
    casas: { type: Number, default: 2 },
    dica: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    // Célula de tabela editável: campo simples, sem o fundo dos formulários.
    compacto: { type: Boolean, default: false },
  },
  data() {
    return { campo: CAMPO };
  },
  computed: {
    propriedades() {
      const base = {
        prefix: this.prefixo || undefined,
        suffix: this.sufixo || undefined,
        disabled: this.disabled,
        dense: true,
      };
      if (this.compacto) return { ...base, hideDetails: true };
      return {
        ...base,
        clearable: !this.disabled,
        flat: true,
        filled: true,
        solo: true,
        hint: this.dica || undefined,
        persistentHint: !!this.dica,
        hideDetails: this.dica ? false : "auto",
      };
    },
    opcoes() {
      return {
        locale: "pt-BR",
        length: 12,
        precision: this.casas,
        empty: null,
      };
    },
  },
};
</script>
